module.exports = __webpack_public_path__ + "media/images/logos/Singapore-Institute-of-Management-bb85a3a533457d7aa191fbcf4cf96fec.svg";